import {GET_ALL_DRIVERS, GET_RECEIVERS} from "../../../utils/Endpoints";
import {GetRequest, GetResultObject} from "../../../utils/API"


const TYPES = {
  REQUEST_DRIVERS: "REQUEST_DRIVERS",
  REQUEST_DRIVERS_SUCCESS: "REQUEST_DRIVERS_SUCCESS",
  REQUEST_DRIVERS_FAILED: "REQUEST_DRIVERS_FAILED",
  UPDATE_DRIVERS_LIST: "UPDATE_DRIVERS_LIST",

  REQUEST_CUSTOMERS: "REQUEST_CUSTOMERS",
  REQUEST_CUSTOMERS_SUCCESS: "REQUEST_CUSTOMERS_SUCCESS",
  REQUEST_CUSTOMERS_FAILED: "REQUEST_CUSTOMERS_FAILED",
  UPDATE_CUSTOMERS_LIST: "UPDATE_CUSTOMERS_LIST",
};

const getDrivers = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_DRIVERS,
      payload: {},
    });

    GetRequest(GET_ALL_DRIVERS, params).then((result) => {
      GetResultObject(result, 'data.content', 200, (datas, {pages, size, total}) => {
        dispatch({
          type: TYPES.REQUEST_DRIVERS_SUCCESS,
          payload: {data: datas, pages, size, total},
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_DRIVERS_FAILED,
        payload: {error},
      });
    });
  }
};

const getCustomers = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CUSTOMERS,
      payload: {},
    });

    GetRequest(GET_RECEIVERS, params).then((result) => {
      GetResultObject(result, 'data.content', 200, (datas, {pages, size, total}) => {
        dispatch({
          type: TYPES.REQUEST_CUSTOMERS_SUCCESS,
          payload: {data: datas, pages, size, total},
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_CUSTOMERS_FAILED,
        payload: {error},
      });
    });
  }
};

export default {
  getDrivers,
  getCustomers,
  TYPES,
};
